import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/clients";

const getClients = async (params = {}) => {
  const response = await api.get(BASE_URL, { params });
  return response.data;
};

const getClientById = async (id) => {
  const response = await api.get(`${BASE_URL}/${id}`);
  return response.data;
};

const createClient = async (payload) => {
  const response = await api.post(BASE_URL, payload);
  return response.data;
};

const updateClient = async ({ id, data }) => {
  const response = await api.patch(`${BASE_URL}/${id}`, data);
  return response.data;
};

const archiveClient = async (id) => {
  const response = await api.patch(`${BASE_URL}/${id}/archive`);
  return response.data;
};

const restoreClient = async (id) => {
  const response = await api.patch(`${BASE_URL}/${id}/restore`);
  return response.data;
};

const clientService = {
  getClients,
  getClientById,
  createClient,
  updateClient,
  archiveClient,
  restoreClient,
};

export default clientService;
